import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import history from "../history";

import Form from './Form.js';
import Admin from './Admin.js';
import Login from './newadmin/Login';
import AdminForm from './AdminForm.js';
import Dashboard from './Dashboard.js';
import HomePage from './HomePage.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import NewAdmin from './NewAdmin.js';
import NotFound from './NotFound.js';
import VOIClientSide from "./voi/VOIClientSide";
import NewDash from "./newdashboard/Dashboard";
import SessionTimeout from './SessionTimeout';


// ADMIN
// The old Metronic admin pages (newadmin/Applications, ClientPage,
// Docs_Settings, Billing, Agents, User) no longer have routes — /admin/* is
// served by the admin2 redesign below. The files are left in place, unreferenced,
// so the old UI can be brought back quickly if needed. newadmin/Login is still
// the live login page and is imported above.
import VOICompleted from './voi/VOICompleted';
import FileUpload from './FileUpload';
import DocumentCollection from './fileupload/DocumentCollection';
import ClientBankStatements from './ClientBankStatements';
import ClientLogin from './ClientLogin';
import ClientAuthRedirect from './ClientAuthRedirect';
import LoanGatewayPrivacyPage from './consent/LoanGatewayPrivacyPage';
import MortgageChoicePrivacyPage from './consent/MortgageChoicePrivacyPage';
import FormV2 from './FormV2';
import FactFindTest from './fact-find-test/FactFindTest';
import FactFindPrint from './fact-find-test/print/FactFindPrint';

// ADMIN2 (the redesigned admin, now serving /admin/*)
import ApplicationsPage from './admin2/pages/ApplicationsPage';
import ApplicationDetailPage from './admin2/pages/ApplicationDetailPage';
import TrackingPage from './admin2/pages/TrackingPage';
import DocsSettingsPage from './admin2/pages/DocsSettingsPage';
import BillingPage from './admin2/pages/BillingPage';
import AgentsPage from './admin2/pages/AgentsPage';
import UserSettingsPage from './admin2/pages/UserSettingsPage';

const App = () => {

  return (
    <div>
      <SessionTimeout />

      <Switch>
        <Route exact path="/" component={HomePage}></Route>
        <Route exact path="/oldadmin" component={Admin}></Route>

        {/* /admin/* is the admin2 redesign. The Metronic pages it replaced are
            still in client/src/components/newadmin/ but no longer routed. */}
        <Route exact path="/admin/applications" component={ApplicationsPage}></Route>
        <Route exact path="/admin/tracking" component={TrackingPage}></Route>
        <Route exact path="/admin/application/:id" component={ApplicationDetailPage}></Route>
        <Route exact path="/admin/settings/uploads" component={DocsSettingsPage}></Route>
        <Route exact path="/admin/settings/billing" component={BillingPage}></Route>
        <Route exact path="/admin/settings/agents" component={AgentsPage}></Route>
        <Route exact path="/admin/settings/user" component={UserSettingsPage}></Route>

        {/* Print views live under /admin/ but are standalone (no admin shell), so
            they must be matched before the bare "/admin" route below. */}
        <Route exact path="/admin/factfindform/:applicationId/print" component={FactFindPrint}></Route>
        <Route exact path="/admin/factfindform/:applicationId/versions/:versionId/print" component={FactFindPrint}></Route>

        <Route exact path="/admin" component={ApplicationsPage}></Route>

        {/* Anything still pointing at /admin2 (bookmarks, saved links) now lands
            on the same page under /admin. Query string and hash are preserved. */}
        <Route
          path="/admin2"
          render={({ location }) => (
            <Redirect
              to={{
                ...location,
                pathname: location.pathname.replace(/^\/admin2/, '/admin'),
              }}
            />
          )}
        ></Route>

        <Route exact path="/login" component={Login}></Route>
        <Route exact path="/privacy-loangateway" component={LoanGatewayPrivacyPage}></Route>
        <Route exact path="/privacy-mortgagechoice" component={MortgageChoicePrivacyPage}></Route>
        {/* Canonical /privacy now serves the current LoanGateway policy
            (same component as /privacy-loangateway). The old generic
            "Mortgage Choice Sydney CBD" boilerplate in standalones/Privacy.js
            has been retired. */}
        <Route exact path="/privacy" component={LoanGatewayPrivacyPage}></Route>
        {/* <Route exact path="/factfindform-v2/:id" component={FormV2}></Route> */}
        <Route exact path="/fact-find-test" component={FactFindTest}></Route>
        <Route exact path="/fact-find/:applicationId" component={FactFindTest}></Route>
        <Route exact path="/factfindform/:id" component={Form}></Route>
        <Route exact path="/identification/:id" component={VOIClientSide}></Route>
        <Route exact path="/upload/:id" component={DocumentCollection}></Route>
        <Route exact path="/bankstatements/:id" component={ClientBankStatements}></Route>
        <Route exact path="/identification/:id/completed" component={VOICompleted}></Route>
        <Route exact path="/adminform/:id" render={(props) => (
          <AdminForm {...props} versions={false}></AdminForm>
        )}></Route>

        <Route exact path="/versions/:application_id/:version_id/:form_id" render={(props) => (
          <AdminForm {...props} versions={true}></AdminForm>
        )}></Route>
        <Route exact path="/dashboard/:id" component={Dashboard}></Route>
        <Route exact path="/client/auth" component={ClientAuthRedirect}></Route>
        <Route exact path="/client" component={ClientLogin}></Route>

        {/* <Route exact path="/newdashboard/:id" component={NewDash}></Route> */}
        <Route path="*"><NotFound></NotFound></Route>
      </Switch>
    </div>

  );
};



export default App;
